import styled from 'styled-components';

export default styled.div`
  cursor: pointer;

  * {
    cursor: pointer;
  }

  .invalid-feedback {
    display: inline-block;
  }
`;
